import React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import patternSelectors from '../../../../store/selectors/pattern.selectors'
import submissionSelectors from '../../../../store/selectors/submission.selectors'
import { useParams } from 'react-router'
import {
    useFetchNotConfidentSubmissionsQuery,
    useFetchSubmissionReviewsQuery,
} from '../../../../store/apis/submission.api'
import {
    fetchNotConfidentSubmissionsSelectors,
    fetchSubmissionReviewsSelectors,
} from '../../../../store/apis/utils/selectors/submission.api.selectors'
import { actions, INITIAL_DRAWER } from '../../../../store/reducers/assignment.reducer'
import { submissionActions } from '../../../../store/slices/submission.slice'
import { Badge } from 'antd'
import { CheckCircleFilled, QuestionCircleFilled, StarFilled } from '@ant-design/icons'
import { primaryColor, successColor, warningColor } from '../../../../constants/styles'
import FileCard from './FileCard'

const FileCardContainer = ({ file, setShowDrawer, setDrawerFile, badgeProps: customBadgeProps }) => {
    const finetunedPatternExists = useSelector(patternSelectors.finetunedPatternExists)
    const isSelected = useSelector(submissionSelectors.isSelected(file.id))
    const isOpened = useSelector(submissionSelectors.isOpened(file.id))
    const dispatch = useDispatch()
    const { token, layerId } = useParams()
    const { data: isNotConfidentSubmission } = useFetchNotConfidentSubmissionsQuery(
        { token, layerId },
        {
            skip: !finetunedPatternExists,
            selectFromResult: result =>
                fetchNotConfidentSubmissionsSelectors.isNotConfidentById({ id: file.id }, result),
        },
    )
    const { data: isReviewed } = useFetchSubmissionReviewsQuery(
        { token, layerId },
        {
            selectFromResult: result => fetchSubmissionReviewsSelectors.isReviewedById({ id: file.id }, result),
        },
    )
    const { data: isReviewedWithCorrections } = useFetchSubmissionReviewsQuery(
        { token, layerId },
        {
            selectFromResult: result =>
                fetchSubmissionReviewsSelectors.isReviewedWithCorrectionsById({ id: file.id }, result),
        },
    )

    const handleFileClick = () => {
        if (isOpened) {
            setShowDrawer(false)
            setDrawerFile(INITIAL_DRAWER)
        } else {
            setShowDrawer(true)
            setDrawerFile(file)
        }
    }

    const handleCheckboxChange = event =>
        event.target.checked
            ? dispatch(submissionActions.addSelectedSubmissionId(file.id))
            : dispatch(submissionActions.removeSelectedSubmissionId(file.id))

    const patternsVisualisation = {
        size: file.seq_size,
        items: file.motifList,
    }

    const fileCard = (
        <FileCard
            id={file.id}
            name={file.name}
            onClick={handleFileClick}
            isSelected={isSelected}
            isOpened={isOpened}
            patternsVisualisation={patternsVisualisation}
            onCheckboxChange={handleCheckboxChange}
        />
    )

    const buildBadgeProps = () => {
        if (customBadgeProps) return customBadgeProps
        if (isReviewedWithCorrections)
            return {
                count: <CheckCircleFilled style={{ color: warningColor }} title='Reviewed with corrections' />,
            }
        if (isReviewed)
            return {
                count: <CheckCircleFilled style={{ color: successColor }} title='Reviewed' />,
            }
        if (isNotConfidentSubmission)
            return {
                count: <QuestionCircleFilled style={{ color: primaryColor }} title='Is not confident' />,
            }
        if (file.is_archetype) return { count: <StarFilled style={{ color: warningColor }} title='Is archetype' /> }
    }
    const badgeProps = buildBadgeProps()

    return badgeProps ? <Badge {...badgeProps}>{fileCard}</Badge> : fileCard
}

const mapDispatch = dispatch => {
    return {
        setShowDrawer(value) {
            dispatch(actions.setShowDrawer(value))
        },
        setDrawerFile(value) {
            dispatch(actions.setDrawerFile(value))
        },
    }
}

export default connect(null, mapDispatch)(FileCardContainer)
